import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { enUS as fnsEn } from 'date-fns/locale';
import { en } from './locales/en';
export var ELanguage;
(function (ELanguage) {
    ELanguage["En"] = "en";
})(ELanguage || (ELanguage = {}));
export const FNS_LOCALE = {
    [ELanguage.En]: fnsEn
};
const translations = {
    [ELanguage.En]: { translation: en }
};
export const defaultLanguage = ELanguage.En;
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    debug: false,
    returnNull: false,
    fallbackLng: defaultLanguage,
    interpolation: {
        escapeValue: false
    },
    resources: translations,
    detection: {
        order: ['localStorage', 'navigator'],
        caches: ['localStorage']
    }
});
export { i18n };
export const getCurrentLocale = () => {
    return i18n.language.split('-')[0];
};
export const getCurrentFnsLocale = () => {
    const language = i18n.language.split('-')[0];
    try {
        // @ts-ignore
        return FNS_LOCALE[language];
    }
    catch {
        return fnsEn;
    }
};
//# sourceMappingURL=i18n.js.map